import {
    ATTEMPT_FETCH_ATHLETE,
    ATTEMPT_FETCH_ATHLETES,
} from 'shared_redux/actions';

export const fetchAthlete = (id) => ({ type: ATTEMPT_FETCH_ATHLETE, id });
export const fetchAthletes = () => ({ type: ATTEMPT_FETCH_ATHLETES });
